import React, { Component, Fragment } from 'react'
import Sidebar from "../navigation/Sidebar";
import TableClientBalance from "./TableClientBalance";
import Rest from "../../services/Rest";

const stateInicial = {
    usuarios: []
}

export default class ClientBalance extends Component {

    constructor(props) {
        super(props)

        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...stateInicial }


    componentDidMount() {
        this.Rest.get("saldos", this.datauser)
            .then(usuarios => {
                if (usuarios.status === 200) {
                    this.setState({
                        usuarios: usuarios.data
                    })
                }
                else {
                    if (usuarios.status === 404) {
                        localStorage.removeItem("ls");
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: usuarios.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: err
                })
            })
    }


    render() {
        return (
            <Fragment>
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Consulta de clientes con saldo</h4>
                                        <div className="table-responsive">
                                            <TableClientBalance data={this.state.usuarios} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/users/ClientBalance.js